import { _t } from "@cruisen/i18n"
import { callFirebaseFunction } from "../callFirebaseFunction.ts"
import { ExchangeAuthTokenOutput } from "@cruisen/contract"

export const exchangeAuthToken = async (
  longTermToken: string,
): Promise<ExchangeAuthTokenOutput["result"]> => {
  const response = await callFirebaseFunction({
    name: "exchangeAuthToken",
    payload: {
      longTermToken,
    },
  })

  if (response.error) {
    alert(`${_t("errors.auth")} ${_t("errors.tryAgainLater")}`)
    return null
  }

  return response.data?.result
}
